import Vue from 'vue';
import punchModal from './punchModal';

let instance;

const fnTypes = ['show'];

const PunchModalConstruct = Vue.extend(punchModal);

const PunchModal = function(options = {}) {
  if (!instance) {
    instance = new PunchModalConstruct({
      data: options
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
  } else {
    Object.assign(instance.$data, options);
  }
  return instance;
};

fnTypes.forEach(type => {
  PunchModal[type] = options => PunchModal(options).open();
});

PunchModal.hide = () => {
  instance && instance.close();
};

PunchModal.destroy = () => {
  instance && instance.destroy();
};

export default PunchModal;
